import styled from 'styled-components';

import {colors, border, font} from '../../theme';

export const ButtonsContainer = styled.div`
    margin-top: 20px;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
`;

export const FlexContainer = styled.div`
    display: flex;
    justify-contetn: space-between;
    gap: 20px;
`;

export const Button = styled.button<{typeView?: 'delete' | 'back' | 'next'; fontSize?: 'small'}>`
    padding: 10px 24px;
    border-radius: ${border.radius};
    font-family: ${font.family.primary};
    font-weight: 600;
    letter-spacing: 2%;
    cursor: pointer;

    ${(p) =>
        p.fontSize === 'small'
            ? `
                padding: 10px 16px;
                font-size: 12px;
                line-height: 16px;
            `
            : `
                padding: 10px 24px;
                font-size: 14px;
                line-height: 24px;
            `}

    ${(p) => {
        switch (p.typeView) {
            case 'back':
                return `
                    color: ${colors.brandPrimary};
                    border: 1px solid ${colors.brandLight};
                    background-color: ${colors.brandLight};
                `;
            case 'delete':
                return `
                    color: #FF3030;
                    border: 1px solid #FF3030;
                    background-color: transparent;
                `;
            case 'next':
                return `
                    color: ${colors.white};
                    border: 1px solid ${colors.brandPrimary};
                    background-color: ${colors.brandPrimary};
                    &:disabled {
                        color: #8A8A8A;
                        background-color: #EFEFEF;
                        border: 1px solid #EFEFEF;
                        cursor: not-allowed;
                    }
                `;
            default:
                return `
                    color: ${colors.white};
                    border: 1px solid ${colors.brandPrimary};
                    background-color: ${colors.brandPrimary};
                `;
        }
    }}
`;
